<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Empresariales</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Seguro de Protección Digital Empresas</h1>
                <p>En un mundo cada vez más conectado, proteger su negocio de virus, acciones maliciosas de ciberdelincuentes y otros riesgos digitales
                es fundamental para que no ponga en riesgo su patrimonio y sus actividades se lleven a cabo de manera tranquila y segura.
                </p>
        </div>
        <div class="especialidades-slide">
            <center><h1>Con el Seguro de Protección Digital Empresas puede:</h1>
            <VueSlickCarousel
                class="slider2"
                ref="slick"
                v-bind="slickOptionsExperiencies"
                :arrows="false">
                <div v-for="(slide, i) in especialidades" :key="i" class="especial">
                    <img :src="slide.image" alt="">
                    <p>{{slide.texto}}</p>
                </div>
            </VueSlickCarousel>
            </center>
        </div>
        <div class="texto">
            <center class="box">
                <p>Internet se ha convertido en una herramienta imprescindible para todas las empresas del mundo en cualquier campo de acción, muy
                útil para ampliar su mercado y suplir diversas necesidades, desde comunicarle sus servicios a un interesado y alojar información, hasta
                recolectar datos personales de clientes potenciales.
                <br>
                <br>
                La realidad, sin embargo, es que la actividad en la web conlleva riesgos que aumentan en la medida en que se descubren novedosas formas
                de asaltar la información y la presencia de las empresas y sus clientes en la red. Si alguien entra sin autorización al sistema de
                información de su compañía y roba o daña datos importantes, está siendo víctima de delitos informáticos y es fundamental que, frente
                situaciones como estas, cuente con un respaldo para no perder la tranquilidad.
                <br>
                <br>
                Para que no ponga en riesgo uno de sus activos más valiosos, como lo es la información, y con ello toda la actividad de su compañía, el Seguro
                de Protección Digital Empresas, la mejor opción para su bienestar y el de sus clientes.
                <br>
                <br>
                <span>Este plan tiene coberturas de responsabilidad civil (daños a terceros) con la posibilidad de asegurar valores desde 20 millones de
                pesos y hasta 400 millones.</span>
                </p>
            </center>
        </div>
        <div class="slide-cobertura-opcional">
            <center><h1>Coberturas</h1></center>
            <VueSlickCarousel
            class="slider"
            ref="slick"
            :autoplay="true"
            :dots="true"
            :arrows="false">
                <div v-for="(slide, i) in coberturaPrincipal" :key="i">
                    <div class="cobertura-principal-slide">
                        <div>
                            <img src="@/assets/Empresarial-Fraude-Empleados/Icon-mano.svg" alt="">
                            <label for="">{{slide.label}}</label>
                        </div>
                       <p v-html="slide.p"></p>
                    </div>
                </div>
            </VueSlickCarousel>
        </div>
        <div class="nocubre">
            <center><h1>¿Qué no cubre el Seguro de Protección Digital Empresas?</h1></center>
            <div v-for="(p, i) in noCubre" :key="i">
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/><p>{{p}}</p>
            </div>
        </div>
        <div class="connect">
            <img src="@/assets/bg-llamado-accion.webp" alt="">
            <h1>¿Qué empresas se pueden asegurar?</h1>
            <p>Cualquier empresa que desee asegurarse de eventos que afecten la seguridad de su información y sea apta luego de un análisis de riesgo
            realizado por la aseguradora</p>
        </div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'Proteccion-Digital-empresas',
    metaInfo() {
        return {
            title: 'Seguro de Protección Digital Empresas',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'En un mundo cada vez más conectado, proteger su negocio de virus, acciones maliciosas de ciberdelincuentes y otros riesgos digitales es fundamental para que no ponga en riesgo su patrimonio y sus actividades se lleven a cabo de manera tranquila y segura.'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Recibe asesoría para cotizar y contratar diferentes tipos de seguros para empresas.'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    components: {
        Aliados,
        VueSlickCarousel
    },
    data() {
        return {
            noCubre: [
                'El deterioro, destrucción o pérdida de bienes tangibles que sean propiedad o estén bajo el dominio, posesión, tenencia o control de su compañía o de terceros.',
                'Reclamaciones derivadas del mantenimiento de los datos y procedimientos de seguridad de la información por parte de la empresa por debajo de los estándares declarados en el formulario de solicitud de este seguro, en el evento que este formulario aplique.',
                'Reclamaciones que se deriven de la obtención no autorizada o ilícita de datos o información de un tercero y el uso de software ilegal, por parte de la empresa.',
                'Pérdidas resultantes de un error de producto, entendiendo por este los comportamientos inesperados de alguna tecnología no descritos en su manual de operación.',
                'Otros.'
            ],
            coberturaPrincipal: [
                {
                    label: 'Responsabilidad por violación de privacidad o confidencialidad:',
                    p: 'Se asumen los perjuicios que su compañía le genere a un tercero por revelar, perder o modificar su información personal o confidencial o, en general, porque hubo un manejo inadecuado de sus datos. La fuga de información se puede dar por ejemplo en una llamada desde un call center o con la divulgación de datos vía correo electrónico.'
                },
                {
                    label: 'Responsabilidad por software malicioso o virus informático',
                    p: 'Se Paga por los perjuicios que su compañía les haya generado a terceros por un incidente cibernético, como un virus, que llegue a sus sistemas, que no haya podido parar y que por consiguiente, haya terminado afectando a ese tercero. Por ejemplo: si le envió a otra compañía un archivo vía correo electrónico que tenía un virus y, cuando este fue abierto, se perdió una gran cantidad de datos, entonces se asumen económicamente los daños generados.'
                },
                {
                    label: 'Responsabilidad por publicación en medios digitales',
                    p: 'Se Paga por los perjuicios que su compañía genere por la divulgación de contenidos en sus medios digitales (sitio web, blog, redes sociales, entre otros). Por ejemplo: si se publica una imagen en el portal web y con ello se violan derechos de autor, o si se difunde una foto de un cliente que afecte su reputación, en un medio digital, se apoyara económicamente para cubrir las reclamaciones o demandas de terceros que su empresa reciba.'
                },
                {
                    label: 'Recuperación de activos digitales',
                    p: 'Si se perdió información de su compañía por la acción de un ciberdelincuente, un virus o un error humano de un empleado por ejemplo, se pagaran los gastos en los que esta incurra para recuperar o reconstruir los datos. Esta cobertura no aplica si la afectación fue generada por un daño físico, por ejemplo, un golpe o la caída de un computador.'
                },
                {
                    label: 'Extorsión Cibernética',
                    p: 'Se responde por el dinero que su empresa pagó a un tercero a cambio de que no afectara sus sistemas informáticos o devolviera información que hurtó. Para activar la cobertura, se debe denunciar la extorsión ante las autoridades.'
                },
                {
                    label: 'Interrupción del negocio',
                    p: 'Si se da un evento de pérdida, es decir, si en su compañía se pierde información de la que depende su funcionamiento a causa de un virus o un ataque cibernético, pagaremos el beneficio económico que esta deje de percibir esos días (lucro cesante). Adicionalmente, se asumen los gastos en los que incurra para que la organización vuelva a la normalidad.'
                },
                {
                    label: 'Transferencias electrónicas',
                    p: 'Se le reembolsará el dinero hurtado como resultado de una transferencia electrónica fraudulenta de un tercero desde su cuenta bancaria, cuando no se pueda recuperar el dinero en el mes siguiente de su pérdida. En cualquier caso, en el evento que el banco realice la devolución del dinero hurtado, este deberá ser transferido a la aseguradora en caso de ya haberse efectuado un pago.'
                },
                {
                    label: 'Gastos de defensa y gastos de investigación oficial',
                    p: 'Su empresa puede enfrentarse a una investigación por parte de alguna autoridad administrativa o puede ser demandada, ambas situaciones a consecuencia de los hechos mencionados en las coberturas de este seguro (fallas en el tratamiento de datos personales, infección de virus informático, entre otras). Se apoyará económicamente con los honorarios de los abogados o todos los gastos para la defensa de su empresa dependiendo del caso por parte de la aseguradora.'
                },
                {
                    label: 'Gastos de emergencia',
                    p: 'Esta cobertura se activa cuando no sea posible conseguir la autorización de la aseguradora para contratar los servicios de gestión de crisis amparados en el seguro.'
                },
                {
                    label: 'Protección de la reputación',
                    p: 'Esta cobertura se activa cuando usted use alguna de las otras que tiene el seguro, es decir, que si lo respaldamos en la cobertura de responsabilidad civil por violación de privacidad o confidencialidad, entonces también cubriremos los gastos en los que deba incurrir su compañía para prevenir o resarcir los efectos negativos que ese hecho puntual generó en su imagen. Por ejemplo: si la imagen de su empresa resultó afectada por una publicación en redes sociales en la que utilizó una marca de una empresa que no le había otorgado autorización para ello, lo apoyamos económicamente para que contrate expertos en imagen corporativa y gestión de crisis para que lo ayuden a mejorar la situación.'
                },
                {
                    label: 'Gastos forenses',
                    p: 'Si se presenta un evento como por ejemplo, su compañía es víctima de un virus o cualquier ataque cibercriminal, se pagaran los gastos en los que se incurra para investigar la fuente o causa del evento.<br>Adicionalmente, se cubre lo que le cueste a su empresa remediar la vulnerabilidad que dio lugar a que se presentara el evento.'
                }
            ],
            slickOptionsExperiencies: {
                'dots': false,
                'arrows': true,
                'focusOnSelect': true,
                'infinite': true,
                'autoplay': true,
                'autoplaySpeed': 3000,
                'speed': 500,
                'slidesToShow': 3,
                'slidesToScroll': 3,
                'touchThreshold': 5,
                'responsive': [
                    {
                        'breakpoint': 1140,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'infinite': true
                        }
                    },
                    {
                        'breakpoint': 680,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'infinite': true
                        }
                    }
                ]
            },
            especialidades: [
                {
                    image: require('@/assets/Proteccion-digital-Empresas/1.png'),
                    texto: 'Proteger su negocio de ataques generados por virus informáticos o ciberdelincuentes.'
                },
                {
                    image: require('@/assets/Proteccion-digital-Empresas/2.png'),
                    texto: 'Resguardar el funcionamiento de su compañía.'
                },
                {
                    image: require('@/assets/Proteccion-digital-Empresas/3.png'),
                    texto: 'Preservar su patrimonio.'
                },
                {
                    image: require('@/assets/Proteccion-digital-Empresas/4.png'),
                    texto: 'Proteger su información y la de sus clientes como activo esencial.'
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>
<style>
    .cobertura-principal-slide > p > span {
        font-weight: bold;
        margin-left: 5em;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 25px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 5px;
        margin-bottom: 15px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
</style>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-empresariales-bg.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
        width: 60%;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .slider2 {
        width: 70%;
    }
    .especialidades-slide{
        padding-top: 40px;
    }
    .especialidades-slide > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        font-size: 30px;
    }
    .especialidades-slide > div {
        height: 500px;
    }
    .especial img {
        width: 100%;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
    }
    .especial > p {
        font-family: 'JR';
        padding: 10px;
        text-align: left;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
    .cobertura-principal {
        width: 100%;
        padding: 0px 300px;
    }
    .cobertura-principal > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
    }
    .cobertura-principal > div {
        display: flex;
        margin-bottom: 50px;
    }
    .cobertura-principal > div > center > img {
        width: 200px;
        height: auto;
    }
    .cobertura-principal > div > div {
        padding: 20px;
    }
    .cobertura-principal > div > div > div > img{
        width: 50px;
        margin-right: 20px;
    }
    .cobertura-principal > div > div > div > label{
        font-family: 'JBD';
        color: #65b24a;
        font-size: 20px;
    }
    .cobertura-principal > div > div {
        padding: 25px;
        margin-top: 20px;
        font-family: 'JR';
        -webkit-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        -moz-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
    }
    .cobertura-principal-slide{
        padding: 0px 300px;
    }
    .cobertura-principal-slide > div {
        display: flex;
    }
    .cobertura-principal-slide > div > label {
        color: #65b24a;
        font-family: 'JBD';
        font-size: 20px;
    }
    .cobertura-principal-slide > div > img {
        width: 50px;
    }
    .cobertura-principal-slide > p {
        font-family: 'JR';
        margin-top: 10px;
        margin-bottom: 60px;
    }
    .slide-cobertura-opcional > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .nocubre {
        padding: 50px 300px;
    }
    .nocubre > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        font-size: 30px;
        margin-bottom: 30px;
    }
    .nocubre > div > p {
        font-family: 'JR';
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    @media (max-width: 1600px) {
        .slider2 {
            width: 60%;
        }
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .slider2 {
            width: 65%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .slider2 {
            width: 70%;
        }
        .nocubre {
            padding: 50px 200px;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal-slide{
            padding: 0px 200px;
        }
        .opcionales {
            padding: 50px 200px;
        }
        .slider2 {
            width: 75%;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
        .nocubre {
            padding: 50px 200px;
        }
    }
    @media (max-width: 1100px) {
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
        .slider2 {
            width: 80%;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            width: 100%;
            padding: 10px;
            text-align: center;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 100px;
        }
        .cobertura-principal-slide{
            padding: 0px 100px;
        }
        .opcionales {
            padding: 50px 100px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
        .move > center > img {
            width: 700px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .cobertura-principal > div {
            display: block;
        }
        .move > center > img {
            width: 600px;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
        .cobertura-principal {
            padding: 10px 50px;
        }
        .cobertura-principal-slide {
            padding: 0px 50px;
        }
        .opcionales {
            padding: 50px 50px;
        }
        .move > center > img {
            width: 500px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
        .move > center > img {
            width: 400px;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
        .slide-cobertura-opcional > center > h1 {
            font-size: 30px;
        }
        .cobertura-principal > center > h1{
            font-size: 30px;
        }
        .nocubre {
            padding: 50px 25px;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
        .move > center > img {
            width: 250px;
        }
        .especial img {
            width: 240px;
        }
        .cobertura-principal > div > div {
            padding: 20px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosEmpresas/ProteccionDigitalEmpresas.vue